
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';

@Options({})
export default class BonificoConfigDetails extends mixins(WithModel) {

    declare localValue: OM.BonificoConfigDetails;

}

